import Videowall from '../views/Videowall/Index'

const routes = {
    path: '/videowall',
    name: 'videowall',
    component: Videowall,
    meta: {
        layout: 'full',
        access_nivel: ['1', '2', '3'],
    },
}

export default routes
